module.exports = "/virtual-football/img/video/clubs/england/m-city.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/england/m-city.png
// module id = 287
// module chunks = 6